import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddClientsForm = ({ closeModal ,onClientAdded}) => {
  // A helper function to get initial data from session storage
  const getInitialClientData = () => {
    try {
      const storedData = sessionStorage.getItem("clientFormData");
      return storedData ? JSON.parse(storedData) : {
        clientName: "",
        company: "",
        group: "",
        Email: "",
        contact: "",
        contactalt: "",
        building: "",
        street: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
        description: "", // Added 'description' field
        field: "",       // Added 'field' field
      };
    } catch (error) {
      console.error("Failed to parse client data from session storage:", error);
      return {
        clientName: "",
        company: "",
        group: "",
        Email: "",
        contact: "",
        contactalt: "",
        building: "",
        street: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
        description: "", // Added 'description' field
        field: "",       // Added 'field' field
      };
    }
  };

  const [clientData, setClientData] = useState(getInitialClientData);

  // Use useEffect to save form data to session storage whenever clientData changes
  useEffect(() => {
    sessionStorage.setItem("clientFormData", JSON.stringify(clientData));
  }, [clientData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClientData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token"); // Get the actual token

    try {
      // Replace the mock code with a real axios post call
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/client`, clientData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      // Check for a successful response from the backend
      if (res.status === 201) {
        toast.success("Client added successfully!");
        console.log("Client added successfully:", res.data.client);

        // Clear session storage and reset the form
        sessionStorage.removeItem("clientFormData");
        setClientData({
          clientName: "",
          company: "",
          group: "",
          Email: "",
          contact: "",
          contactalt: "",
          building: "",
          street: "",
          city: "",
          district: "",
          state: "",
          pincode: "",
          description: "", // Reset the new fields
          field: "",       // Reset the new fields
        });
          // 🔑 THIS IS THE KEY CHANGE
        if (onClientAdded) {
          onClientAdded(); 
        }

        if (closeModal) closeModal();
      }
    } catch (error) {
      console.error("Error adding client:", error);
      if (error.response) {
        console.error("Server responded with:", error.response.data);
        console.error("Status code:", error.response.status);
        toast.error(`Failed to add client: ${error.response.data.error || "Server error"}`);
      } else if (error.request) {
        console.error("No response received:", error.request);
        toast.error("Failed to add client. No response from server.");
      } else {
        console.error("Error message:", error.message);
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <div className="w-full">
      <ToastContainer />
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-semibold text-center mb-6">
          Add Client To Workspace
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Client Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Client Name</label>
              <input
                type="text"
                name="clientName"
                value={clientData.clientName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\s]*$/.test(value)) {
                    handleChange(e);
                  }
                }}
                required
                className="w-full border rounded px-3 py-2"
                placeholder="Enter client name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Company</label>
              <input
                type="text"
                name="company"
                value={clientData.company}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Enter company name (optional)"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Group</label>
              <input
                type="text"
                name="group"
                value={clientData.group}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Enter group name (optional)"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Field</label>
              <input
                type="text"
                name="field"
                value={clientData.field}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Enter client's field of work (optional)"
              />
            </div>
          </div>
          {/* Contact Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                name="Email"
                value={clientData.Email}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
                placeholder="Enter email address"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Contact</label>
              <input
                type="tel"
                name="contact"
                value={clientData.contact}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                required
                pattern="\d{10}"
                inputMode="numeric"
                maxLength={10}
                className="w-full border rounded px-3 py-2"
                placeholder="Enter 10-digit mobile number"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Alternate Contact</label>
              <input
                type="tel"
                name="contactalt"
                value={clientData.contactalt}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                required
                pattern="\d{10}"
                inputMode="numeric"
                maxLength={10}
                className="w-full border rounded px-3 py-2"
                placeholder="Enter alternate 10-digit mobile number"
              />
            </div>
          </div>
          {/* Address Information */}
          <div className="border rounded p-4 space-y-4 bg-gray-50">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Building</label>
                <input
                  type="text"
                  name="building"
                  value={clientData.building}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                  placeholder="Enter building name/no."
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Street</label>
                <input
                  type="text"
                  name="street"
                  value={clientData.street}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                  placeholder="Enter street name"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">City</label>
                <input
                  type="text"
                  name="city"
                  value={clientData.city}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                  placeholder="Enter city name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  name="state"
                  value={clientData.state}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                  placeholder="Enter state name"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">District</label>
              <textarea
                name="district"
                value={clientData.district}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
                placeholder="Enter district name"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Pincode</label>
                <input
                  type="number"
                  name="pincode"
                  value={clientData.pincode}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                  placeholder="Enter pincode"
                />
              </div>
            </div>
          </div>
          {/* New Description field outside of address info section */}
          <div>
            <label className="block text-sm font-medium mb-1">Description</label>
            <textarea
              name="description"
              value={clientData.description}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              rows="4"
              placeholder="Enter a detailed description (optional)"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-green-600 text-white px-4 py-3 rounded hover:bg-green-700"
          >
            Submit Client
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddClientsForm;